/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Existing_TitleInputs */

const en_existing_title = /** @type {(inputs: Existing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From a codebase`)
};

const id_existing_title = /** @type {(inputs: Existing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dari codebase`)
};

/**
* | output |
* | --- |
* | "From a codebase" |
*
* @param {Existing_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const existing_title = /** @type {((inputs?: Existing_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Existing_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_existing_title(inputs)
	return en_existing_title(inputs)
});